module.exports = __webpack_public_path__ + "img/m_intrduce_bg.8917b7af.png";